import { render, staticRenderFns } from "./SurveyByModel.vue?vue&type=template&id=10476d34&scoped=true&"
import script from "./SurveyByModel.vue?vue&type=script&lang=js&"
export * from "./SurveyByModel.vue?vue&type=script&lang=js&"
import style0 from "./SurveyByModel.vue?vue&type=style&index=0&id=10476d34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10476d34",
  null
  
)

export default component.exports